import { useDispatch, useSelector } from "react-redux";

// Actions
import {
  selectRoadStretch,
  unselectRoadStretch,
} from "../../actions/campaign-planning/CampaignPlanningRoadStretchesActions";
import { openPoiForm } from "../../actions/campaign-planning/PoiFormActions";

// Constants and Utils
import { ProohFormDataTargets } from "../../constants/GeneralConstants";

// Components
import Spinner from "../../../components/spinner/Spinner";

// Util Components
export function LoadingRoadStretches() {
  return (
    <div className="d-flex justify-content-center p-2 bg-alt border">
      <Spinner />
      <span className="ml-2 py-1">
        Please wait, Road Stretches are Loading...
      </span>
    </div>
  );
}

export function LoadingPlanningMapView() {
  return (
    <div className="d-flex justify-content-center p-2">
      <Spinner />
    </div>
  );
}

export function StretchSelectionButton({ stretchInfo }) {
  const dispatch = useDispatch();

  const stretchId = stretchInfo.id;
  const stretchSelected = useSelector(
    (state) => state.planningRoadStretches.selectedStretches[stretchId]
  );

  function unSelectStretch() {
    dispatch(unselectRoadStretch(stretchSelected));
  }

  function selectStretch() {
    dispatch(selectRoadStretch(stretchInfo));
  }

  if (stretchSelected) {
    return (
      <td className="col-2 align-middle text-right">
        <button
          type="button"
          className="btn added-button shadow-none btn-outline-success"
          onClick={unSelectStretch}
        >
          <i className="fa fa-check"></i> <b>Selected</b>
        </button>
      </td>
    );
  }
  return (
    <td className="col-2 align-middle text-right">
      <button
        type="button"
        className="btn add-button shadow-none btn-outline-primary"
        onClick={selectStretch}
      >
        <b>Select</b>
      </button>
    </td>
  );
}

export function AddCaptiveAreaSection() {
  const dispatch = useDispatch();

  // for add-poi/captive-area popup modal
  function openPoiFormFunction() {
    dispatch(openPoiForm());
  }
  return (
    <button
      type="button"
      className="btn btn-link nav-link shadow-none p-0"
      data-toggle="modal"
      data-target={`#${ProohFormDataTargets.addCaptiveAreaForm}`}
      onClick={openPoiFormFunction}
    >
      + Add POI/Captive Area
    </button>
  );
}
